import React from 'react'
import ConnectorIcon from '../../../../../../../SharedComponents/ConnectorIcon/ConnectorIcon'

const MatchedEntity = (props) => {
  const entityId = props.entityName.replace(/\s/g, '')
  const sourceLabel = props.sourceShortName || 'ERP'
  const targetLabel = props.targetShortName || 'EC'
  return (
    <div id={entityId} className={"col-lg-6 mb-3 entityList " + entityId}>
        <div className="entity-card">
            <h5 className="entity-card-title">{props.entityName}</h5>
            <div className="entity-sync">
                <span className="entity-endpoint" title={sourceLabel}>
                    <ConnectorIcon shortName={sourceLabel} className="entity-endpoint-img" />
                </span>
                <div className="entity-flows">
                    <div className="entity-flow" title={`${sourceLabel} to ${targetLabel}`}>
                        <span className="entity-flow-count">{props.sourceCount ? props.sourceCount : 0}</span>
                    </div>
                    <div className="entity-flow entity-flow-reverse" title={`${targetLabel} to ${sourceLabel}`}>
                        <span className="entity-flow-count">{props.targetCount ? props.targetCount : 0}</span>
                    </div>
                </div>
                <span className="entity-endpoint" title={targetLabel}>
                    <ConnectorIcon shortName={targetLabel} className="entity-endpoint-img" />
                </span>
            </div>
        </div>
    </div>
  )
}

export default MatchedEntity